import React from "react";
import { IconButton } from "@src/components";

interface ExpertSettlementListColumnsProps {
    statusList: { no: number; value: string }[];
    onPayOut: (settlementLedgerNo: number) => void;
}

export const getExpertSettlementListColumns = ({ onPayOut, statusList }: ExpertSettlementListColumnsProps) => {
    return [
        {
            Header: "정산 월",
            accessor: "settledMonth",
            Cell: ({ cell: { value } }: any) => <div style={{ textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "전문가 이름",
            accessor: "expertName",
            Cell: ({ cell: { value } }: any) => <div style={{ textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "전문가 연락처",
            accessor: "expertPhone",
            Cell: ({ cell: { value } }: any) => <div style={{ textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "의뢰인 이름",
            accessor: "name",
            Cell: ({ cell: { value } }: any) => <div style={{ textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "의뢰인 연락처",
            accessor: "phone",
            Cell: ({ cell: { value } }: any) => <div style={{ textAlign: "center" }}>{value}</div>,
        },

        {
            Header: "사건번호",
            accessor: "subId",
            Cell: ({ cell: { value } }: any) => <div style={{ textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "정산 금액",
            accessor: "totalAmount",
            Cell: ({ cell: { value } }: any) => <div style={{ textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "수수료",
            accessor: "feeAmount",
            Cell: ({ cell: { value } }: any) => <div style={{ textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "지급 금액",
            accessor: "netAmount",
            Cell: ({ cell: { value } }: any) => <div style={{ textAlign: "center", fontWeight: "bold" }}>{value}</div>,
        },
        {
            Header: "지급 예정일",
            accessor: "payExpectAt",
            Cell: ({ cell: { value } }: any) => <div style={{ textAlign: "center" }}>{value}</div>,
        },
        {
            Header: "의뢰인 확인 상태",
            accessor: "userChecked",
            Cell: ({ cell: { value } }: any) => (
                <div style={{ textAlign: "center" }}>
                    <span
                        style={{
                            backgroundColor: "#D4D4D8",
                            borderRadius: "24px",
                            padding: "4px 8px",
                        }}
                    >
                        {value === true ? "완료" : "대기중"}
                    </span>
                </div>
            ),
        },
        {
            Header: "정산 상태",
            accessor: "status",
            Cell: ({ cell: { value } }: any) => (
                <div style={{ textAlign: "center" }}>
                    <span
                        style={{
                            padding: "4px 8px",
                            borderRadius: "24px",
                            color: "#fff",
                            backgroundColor:
                                value === "정산 완료" ? "#8F50EA" : value === "정산 실패" ? "#Ff0000" : "#51D1FF",
                            lineHeight: "1.4",
                        }}
                    >
                        {value}
                    </span>
                </div>
            ),
        },
        {
            Header: "정산 완료처리  (정산 번호)",
            accessor: "no",
            Cell: ({ cell: { value } }: any) => {
                const status = statusList.find((status) => status.no === value);
                return (
                    <div
                        style={{
                            textAlign: "center",
                            display: "flex",
                            gap: "24px",
                            position: "relative",
                            justifyContent: "space-evenly",
                            alignItems: "center",
                        }}
                    >
                        <span
                            style={{
                                padding: "4px 16px",
                                borderRadius: "24px",
                                border: `1px solid ${status?.value === "정산 대기" ? "#2275EE" : "#D4D4D8"}`,
                                color: status?.value === "정산 대기" ? "#2275EE" : "#D4D4D8",
                                lineHeight: "1.4",
                                cursor: status?.value === "정산 대기" ? "pointer" : "not-allowed",
                            }}
                            onClick={() => {
                                if (status?.value === "정산 대기") {
                                    onPayOut(value);
                                } else {
                                    alert("정산 대기 상태가 아닙니다");
                                }
                            }}
                        >
                            완료하기
                        </span>
                        <div
                            style={{
                                position: "absolute",
                                left: "67%",
                                width: "1px",
                                height: "40px",
                                backgroundColor: "#F4F5F7",

                                transform: "translateY(-2px)",
                            }}
                        />
                        <span
                            style={{
                                lineHeight: "1.4",
                            }}
                        >
                            {value}
                        </span>
                    </div>
                );
            },
        },

        // {
        //     Header: "신청 내역 보러가기",
        //     accessor: "viewMore",
        //     Cell: ({ row }: any) => (
        //         <div
        //             style={{
        //                 display: "flex",
        //                 justifyContent: "center",
        //                 width: "40px",
        //             }}
        //         >
        //             <IconButton
        //                 type="arrow"
        //                 handleClick={() => {
        //                     navigate(`/experts/approval/detail/${row?.original?.expertUserNo}`);
        //                 }}
        //             />
        //         </div>
        //     ),
        // },
    ];
};
